import { render } from "./ListePoidsPage.vue?vue&type=template&id=24562532&ts=true"
import script from "./ListePoidsPage.vue?vue&type=script&lang=ts"
export * from "./ListePoidsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__